import ApiClient from './ApiClient';

class ChatbotFlowsAPI extends ApiClient {
  constructor() {
    super('chatbot_flows', { accountScoped: true });
  }
}

export default new ChatbotFlowsAPI();
